import { useEffect } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import { useExposureEvent } from '@alltrails/experiments';

const useScrollAuthHoldoutExposureOnMount = () => {
  const user = useUser();
  const sendExposure = useExposureEvent('web-growth-rm-scroll-auth-holdout');

  useEffect(() => {
    if (!user) {
      sendExposure();
    }
  }, [sendExposure, user]);
};

export default useScrollAuthHoldoutExposureOnMount;
